import React, { useState } from 'react';
import { func, arrayOf, shape, string, number } from 'prop-types';

import { MOBILE_VIEW_WIDTH_THREASHOLD } from 'src/util/PrioritizeUtil'
import './BubbleTabs.scss';

const BubbleTabs = ({ currentTabIdx, availableIdxs, tabs, onClick: propOnClick }) => {
  const isMobile = window.innerWidth <= MOBILE_VIEW_WIDTH_THREASHOLD

  const bubbleClassName = (currentTabIdx, idx, availableIdxs) => {
    let className = 'bubble'
    if (!availableIdxs.includes(`${idx}`)) className += ' disabled'
    if (currentTabIdx === idx) className += ' current'
    return className
  }

  const rectanglelcassName = (side) => {
    let className = 'rectangle'
    if (side === 'left' && currentTabIdx === 0) className += ' disabled'
    if (side === 'right' && !availableIdxs.includes(String(currentTabIdx + 1))) className += ' disabled'
    return className
  }

  const onClick = (idx, id) => () => {
    if (availableIdxs && !availableIdxs.includes(String(idx)))
      return

    if (propOnClick)
      propOnClick(id)
  }

  const onArrowClick = (side) => () => {
    if (availableIdxs && side === 'right' && !availableIdxs.includes(String(currentTabIdx + 1)))
      return
    if (availableIdxs && side === 'left' && !availableIdxs.includes(String(currentTabIdx - 1)))
      return

    if (propOnClick)
      propOnClick(side === 'left' ? tabs[currentTabIdx - 1].id : tabs[currentTabIdx + 1].id)
  }

  return (
    <div className={`bubble_tabs ${isMobile ? 'mobile' : ''}`}>
      <ul className="bubbles">
        {tabs.map((tab, idx) => (
          <li
            className={bubbleClassName(currentTabIdx, idx, availableIdxs)}
            onClick={onClick(idx, tab.id)}
            key={idx}
          >
            <span className="bubbles__number">{idx + 1}</span>
          </li>
        ))}
      </ul>
      {!isMobile && tabs.length > 0 && (
        <div className="arrows">
          <div
            onClick={onArrowClick('left')}
            className={rectanglelcassName('left')}
          >
            <div className="arrow left"></div>
          </div>
          <div
            onClick={onArrowClick('right')}
            className={rectanglelcassName('right')}
          >
            <div className="arrow right"></div>
          </div>
        </div>
      )}
    </div>
  )

}

BubbleTabs.propTypes = {
  tabs: arrayOf(shape({
    id: string.isRequired,
    title: string.isRequired,
  })),
  currentTabIdx: number,
  availableIdxs: arrayOf(string),
  onClick: func
};

BubbleTabs.defaultProps = {
  tabs: [],
  currentTabIdx: 0,
  availableIdxs: [],
  onClick: () => { }
};

export default BubbleTabs